<div class="flex flex-col gap-4 p-5 border rounded-md">
  <h2 class="font-semibold text-4">{{ title }}</h2>
  <!-- FORM -->
  <form class="flex flex-col gap-5" [formGroup]="performanceForm">
    <!-- DATE -->
    <div class="flex flex-col gap-2">
      <h3 class="text-2 font-medium uppercase">{{ translatePrefix + 'date' | translate }}</h3>
      <div class="grid grid-cols-3 gap-4">
        <app-custom-calendar
          [isHasAllTime]="true"
          [required]="true"
          [isInput]="true"
          [title]="translatePrefix + 'date' | translate"
          [(datesSelected)]="dates"
          [maxDate]="dateNow"></app-custom-calendar>
      </div>
    </div>

    <!-- OBJECTIVE SELECTION -->
    <div class="flex flex-col gap-2">
      <h3 class="text-2 font-medium uppercase">{{ translatePrefix + 'objective-selection' | translate }}</h3>
      <div class="grid grid-cols-3 gap-4">
        <app-form-control
          [control]="performanceForm.get('groupBy')"
          [floatLabel]="true"
          [label]="translatePrefix + 'group-by' | translate">
          <p-dropdown
            input
            [options]="groupByOptions"
            styleClass="w-full h-12"
            optionLabel="label"
            optionValue="value"
            formControlName="groupBy"
            dropdownIcon="icon-wl-arrow-drop-down">
          </p-dropdown>
        </app-form-control>

        <app-user-form-dropdown
          [multiple]="true"
          [label]="translatePrefix + 'user-added' | translate"
          class="!h-11"
          placeholder="Select"
          formControlName="users"
          optionLabel="fullName"
          userType="note"></app-user-form-dropdown>

        <app-form-control
          [control]="performanceForm.get('types')"
          [floatLabel]="true"
          [label]="translatePrefix + 'type-note' | translate">
          <p-multiSelect
            input
            [virtualScroll]="true"
            [lazy]="true"
            [virtualScrollItemSize]="40"
            (onLazyLoad)="onLoadMoreNoteTypes($event)"
            display="chip"
            [filter]="false"
            formControlName="types"
            optionLabel="name"
            optionValue="id"
            styleClass="w-full h-12"
            [options]="noteTypes"
            dropdownIcon="icon-wl-arrow-drop-down">
            <ng-template let-value pTemplate="selectedItems">
              <span>{{ getNoteTypesValue(value) || 'All types' }}</span>
            </ng-template>
          </p-multiSelect>
        </app-form-control>
      </div>
    </div>
  </form>
  <div class="flex flex-row">
    <app-button
      variant="outline-primary"
      [label]="exportSelectedFieldsText | translate"
      size="sm"
      (click)="isSelectionDialogVisible = true">
    </app-button>
  </div>

  <!-- ACTIONS -->
  <div class="flex items-center gap-2 justify-end">
    @if (usersValue?.length || groupByValue || dates.length === 2) {
      <app-button
        variant="ghost-primary"
        [label]="'action.reset' | translate"
        size="sm"
        (onClick)="onReset()"></app-button>
    }

    <app-button
      [label]="translatePrefix + 'run-report' | translate"
      size="sm"
      [disabled]="performanceForm.invalid || dates.length < 2"
      [loading]="isRunning"
      (onClick)="onRunReport()"></app-button>
  </div>
</div>

<app-report-field-selection
  [(visible)]="isSelectionDialogVisible"
  [(data)]="exportSelectedFields"
  [requiredFields]="requiredExportFieldsNoteKey"
  [isAllFieldSelected]="isAllExportFieldsSelected"
  (isAllFieldSelectedChange)="toggleAllExportFields($event)">
</app-report-field-selection>